import React, { useEffect } from 'react';
import { ageTypes, appointmentTypeOptions, genderOptions, maritalOptions } from "../../utils/staticData";

const inputClass = "w-full px-3 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:border-[#12AB81] bg-white text-sm";
const labelClass = "block text-xs font-semibold text-gray-500 mb-1";

const CreateNewAppointment = ({ formData, handleSubmit, locationData, doctorList, setFormData, setDoctorList }: any) => {
    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prev: any) => ({ ...prev, [name]: prev[name] === value ? '' : value }));
    };

    const handleLocationChange = (e: any) => {
        const { name, value } = e.target;
        const selectedLocation = locationData[e.target?.selectedIndex - 1] || {};
        setDoctorList(selectedLocation?.doctors || []);
        setFormData((prev: any) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (locationData?.length > 0) {
            const first = locationData[0];
            setFormData((prev: any) => ({ ...prev, visitLocation: first?._id || '', doctorId: first?.doctors[0]?._id || '' }));
            setDoctorList(first?.doctors || []);
        }
    }, [locationData, setFormData, setDoctorList]);

    return (
        <div className="bg-white rounded-2xl shadow-sm p-4">
            <form onSubmit={handleSubmit} className="space-y-3">

                <div>
                    <label className={labelClass} htmlFor="name">Full Name <span className="text-red-500">*</span></label>
                    <input className={inputClass} type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
                </div>

                <div>
                    <label className={labelClass} htmlFor="patientId">Patient ID</label>
                    <input className={`${inputClass} bg-gray-50 text-gray-400`} type="text" id="patientId" name="patientId" disabled value={formData.patientId} onChange={handleChange} />
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={labelClass} htmlFor="phoneNumber">Phone</label>
                        <input className={inputClass} type="text" id="phoneNumber" name="phoneNumber" value={formData?.phoneNumber} onChange={handleChange} />
                    </div>
                    <div>
                        <label className={labelClass} htmlFor="email">Email</label>
                        <input className={inputClass} type="email" id="email" name="email" value={formData?.email} onChange={handleChange} />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={labelClass} htmlFor="age">Age <span className="text-red-500">*</span></label>
                        <input className={inputClass} type="text" inputMode="decimal" pattern="[0-9]*\.?[0-9]*" id="age" name="age" value={formData.age} onChange={handleChange} required />
                    </div>
                    <div>
                        <label className={labelClass} htmlFor="ageType">Age Type</label>
                        <select className={inputClass} id="ageType" name="ageType" value={formData.ageType} onChange={handleChange}>
                            {ageTypes?.map((t) => (
                                <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div>
                    <label className={labelClass} htmlFor="dateOfBirth">Date of Birth <span className="text-red-500">*</span></label>
                    <input className={inputClass} type="date" id="dateOfBirth" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} required />
                </div>

                <div>
                    <label className={labelClass} htmlFor="address">Address</label>
                    <textarea className={inputClass} rows={2} id="address" name="address" value={formData.address} onChange={handleChange} />
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={labelClass} htmlFor="bloodGroup">Blood Group</label>
                        <select className={inputClass} id="bloodGroup" name="bloodGroup" value={formData?.bloodGroup || ""} onChange={handleChange}>
                            <option value="">Select</option>
                            {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(b => <option key={b} value={b}>{b}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className={labelClass} htmlFor="gender">Gender <span className="text-red-500">*</span></label>
                        <select className={inputClass} id="gender" name="gender" value={formData?.gender?.toLowerCase() || ""} onChange={handleChange} required>
                            <option value="">Select</option>
                            {genderOptions?.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
                        </select>
                    </div>
                </div>

                <div>
                    <label className={labelClass}>Marital Status</label>
                    <div className="flex items-center gap-4">
                        {maritalOptions?.map(o => (
                            <label key={o.id} className="flex items-center gap-1.5 text-sm text-gray-600">
                                <input
                                    type="checkbox"
                                    name="maritalStatus"
                                    value={o.id}
                                    checked={formData.maritalStatus?.toLowerCase() === o.id?.toLowerCase()}
                                    onChange={handleChange}
                                    className="accent-[#12AB81]"
                                />
                                {o.label}
                            </label>
                        ))}
                    </div>
                </div>

                <div>
                    <label className={labelClass} htmlFor="appointmentDate">Appointment Date <span className="text-red-500">*</span></label>
                    <input className={inputClass} type="date" id="appointmentDate" name="appointmentDate" value={formData?.appointmentDate} onChange={handleChange} />
                </div>

                <div>
                    <label className={labelClass}>Appointment Type <span className="text-red-500">*</span></label>
                    <div className="flex items-center gap-4">
                        {appointmentTypeOptions?.map(o => (
                            <label key={o.id} className="flex items-center gap-1.5 text-sm text-gray-600">
                                <input
                                    type="checkbox"
                                    name="appointmentType"
                                    value={o.id}
                                    checked={formData.appointmentType === o.id}
                                    onChange={handleChange}
                                    className="accent-[#12AB81]"
                                />
                                {o.label}
                            </label>
                        ))}
                    </div>
                </div>

                <button
                    type="submit"
                    className="w-full py-3 bg-[#12AB81] text-white rounded-xl font-semibold text-sm active:opacity-80 mt-2"
                >
                    Create Appointment
                </button>
            </form>
        </div>
    );
};

export default CreateNewAppointment;
